<template lang="pug">
v-dialog(data-cy="active-contacts-modal.dialog" :value="value" persistent width='800px')
  v-card
    title-bar(data-cy="active-contacts-modal.title" dark) {{ `${title}: ${total}` }}
    v-flex.pa-4.flex
      span(data-cy="active-contacts-modal.description" xs12) {{ description }}
      div.column-wrapper(xs12)
        div(v-for='contact in contacts' :key="contact.id").column
          router-link(:to="{ path: `/contacts/${contact.id}`}" target="_blank") {{ contact | getFullName | replaceBlankName }}
      v-layout.pagination(xs12)
        v-flex.limits
          pagination-limit.mr-4(
            :limits="paginationLimits"
            :current-limit="limit"
            @change:limit="setPageLimit"
            )
        v-flex.pages
          v-pagination(
            :value="getPage"
            :length="pageCount"
            @input="setPage"
            :total-visible="7"
            v-show="pageCount > 1"
          )
    v-card-actions
      v-spacer
      v-btn(data-cy="active-contacts-modal.close" flat @click="closeDialog") Close
</template>

<script>
import TitleBar from '@/Core/components/TitleBar';
import PaginationLimit from '@/Core/components/PaginationLimit';
import getFullName from '@/Core/filters/getFullName';
import replaceBlankName from '@/Core/filters/replaceBlankName';

export default {
  components: {
    TitleBar,
    PaginationLimit,
  },
  filters: {
    getFullName,
    replaceBlankName,
  },
  data() {
    return {
      paginationLimits: [15, 30, 45, 60],
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'ACTIVE CONTACTS',
    },
    description: {
      type: String,
      default: 'This campaign is currently running for contacts: ',
    },
    contacts: {
      type: Array,
    },
    total: {
      type: Number,
    },
    skip: {
      type: Number,
    },
    limit: {
      type: Number,
    }
  },

  computed: {
    getPage() {
      return Math.floor(this.skip / this.limit) + 1;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit) || 0;
    },
  },

  methods: {
    setPage(page) {
      this.$emit('setPage', page);
    },
    setPageLimit(limit) {
      this.$emit('setPageLimit', limit);
    },
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>

.column-wrapper {
  max-height: 33vh;
  padding-top: 12px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
}

.column {
  width: 33.33%;
  padding: 3px;
}

.pagination {
  height: 60px;
}
</style>
